export class GlobalConstants {

  public static GuestUser: string = "GuestUser";
  public static Moderator: string = "Moderator";
  public static Publisher: string = "Content Publisher";
  public static dloUser: string = "dloUser";
  public static Published: string = "Published";
  public static Drafted: string = "Drafted";
  public static PendingApproval: string = "Pending Approval";
  public static Deleted: string = "Deleted";
  public static Rejected: string = "Rejected";
  public static Scheduled: string = "Scheduled";
  public static Expired: string = "Expired";
  public static Public: string = "Public";
  public static Restricted: string = "Restricted";
  public static contentLimit:number = 28;
  public static AttchStatusCreate: string = "create";
  public static AttchStatusDelete: string = "delete";
  public static AttchStatusUpdate: string = "update";
}
